export default "__VITE_ASSET__C_K3G42R__"